import CrowdaaAPI from 'crowdaa-api';
import ErrorMessage from 'crowdaa-ux/components/ErrorMessage';
import PropTypes from 'prop-types';
import React from 'react';
import UserContext from 'crowdaa-ux/contexts/UserContext';
import shuffle from 'lodash/shuffle';
import { connect } from 'react-refetch';
import { intlShape } from 'react-intl';
import Loading from '../components/Loading';
import VideoPlaylist from './VideoPlaylist';

class VideoPlaylistPage extends React.PureComponent {
  static propTypes = {
    autoplay: PropTypes.bool,
    isMobile: PropTypes.bool,
    selectionFetch: PropTypes.object.isRequired,
    selectionId: PropTypes.string.isRequired,
    trackId: PropTypes.string,
    url: PropTypes.string,
    videos: PropTypes.object,
  };

  static contextTypes = {
    apiURL: PropTypes.string,
    intl: intlShape,
    loginToken: PropTypes.string,
    userId: PropTypes.string,
  };

  static defaultProps = {
    autoplay: false,
    trackId: null,
    url: null,
    isMobile: false,
  };

  state = {
    loadingTimerId: -1,
    loadingDone: false,
  };

  componentDidMount() {
    if (this.state.loadingTimerId < 0) {
      const loadingTimeMinimumWait = 3000;

      this.setState({
        loadingTimerId: setTimeout(() => {
          this.setState({
            loadingDone: true,
          });
        }, loadingTimeMinimumWait),
      });
    }
  }

  componentWillUnmount() {
    if (this.state.loadingTimerId > 0) {
      clearTimeout(this.state.loadingTimerId);
    }
  }

  render() {
    const fluid = false;
    const height = 400;
    const { formatMessage } = this.context.intl;
    const { loadingDone } = this.state;

    const {
      selectionFetch,
      url,
      selectionId,
      trackId,
      autoplay,
      isMobile,
    } = this.props;
    const timerThreshold = 3;
    if (selectionFetch.pending || !loadingDone) return <Loading container='div' url="https://trace.tv/wp-content/uploads/2016/11/logo_africa1.png" />;
    if (selectionFetch.rejected) return <ErrorMessage error={selectionFetch.reason} />;
    if (selectionFetch.value) {
      const { videos } = selectionFetch.value;
      if (!videos || !videos.length) {
        return (
          <ErrorMessage error={new Error(formatMessage({ id: 'no_video_here' }))} />
        );
      }
      return (
        <UserContext.Consumer>
          {user => <VideoPlaylist
            fluid={fluid}
            height={height}
            autoplay={autoplay}
            timerThreshold={timerThreshold}
            trackId={trackId}
            videos={videos}
            selectionId={selectionId}
            url={url}
            user={user}
            isMobile={isMobile}
            shareTitle={selectionFetch.value.selectionDisplayName}
          />}
        </UserContext.Consumer>
      );
    }
    return null;
  }
}

export default connect.defaults(
  new CrowdaaAPI({ type: '', duration: 5 * 60000 }),
)((props, context) => {
  const { apiURL } = context;
  const { selectionId } = props;
  return {
    selectionFetch: {
      context,
      url: `${apiURL}/selections/${selectionId}`,
      then: (selection) => {
        const value = selection;
        value.randomTracks = shuffle(value.tracks);
        const tmp = [];
        value.tracks.forEach((element) => {
          if (element.collection === 'video') {
            tmp.push(element);
          }
        });
        value.videos = tmp;
        return { value };
      },
    },
  };
})(VideoPlaylistPage);
